import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  formWrapper: {
    position: 'relative'
  },
  AdditionalInfoRow: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    '& .MuiInputLabel-root': {
      color: theme.palette.text.primary,
      minWidth: 170,
      [theme.breakpoints.down('xs')]: {
        width: '100%'
      },
      [theme.breakpoints.up('sm')]: {
        margin: 0,
        paddingRight: theme.spacing(2)
      }
    },
    '&.alignTop': {
      alignItems: 'flex-start'
    },
    '& .MuiFormControl-root': {
      width: 340,
      [theme.breakpoints.down('xs')]: {
        width: '100%'
      }
    },
    // '& .MuiTextField-root': {
    //   [theme.breakpoints.up('sm')]: {
    //     maxWidth: 228
    //   }
    // },
    '& .MuiFormGroup-root[role="radiogroup"]': {
      flexDirection: 'row',
      '& .MuiFormControlLabel-root': {
        marginBottom: theme.spacing(0)
      }
    },
    '& a': {
      display: 'block',
      width: '100%',
      textAlign: 'right'
    },
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap'
    },
    [theme.breakpoints.up('sm')]: {}
  },
  PhoneInputWrapper: {
    direction: theme.direction === 'ltr' ? 'ltr' : 'rtl',
    textAlign: 'right',
    width: '100%',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
    '& .react-tel-input': {
      fontFamily: 'inherit'
    },
    '& .react-tel-input .form-control': {
      width: 340,
      paddingTop: theme.spacing(1.3125),
      paddingBottom: theme.spacing(1.3125),
      [theme.breakpoints.down('xs')]: {
        width: '100%'
      },
      '&[disabled]': {
        backgroundColor: theme.palette.secondary.main
      }
    },
    '& .country-list': {
      direction: 'ltr',
      textAlign: 'left',
      '& .search': {
        paddingLeft: theme.spacing(1.25)
      },
      '& .search-box': {
        marginLeft: theme.spacing(1)
      },
      '& .country-name': {
        marginRight: theme.spacing(1)
      },
      '& .dial-code': {
        direction: 'rtl',
        textAlign: 'right',
        display: 'inline-block'
      }
    }
  },
  AdditionalInfoPhoneRow: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.only('sm')]: {
      width: 340
    },
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
      justifyContent: 'flex-end'
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    }
  },
  changePhoneButton: {
    color: theme.palette.primary.light,
    background: 'transparent',
    border: 'none',
    marginLeft: theme.spacing(2)
  },
  ChangePhoneVerifyWrapper: {
    whiteSpace: 'pre-line',
    textAlign: 'center'
  },
  ChangePhoneVerify: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginBottom: theme.spacing(2),
    '& .MuiInputLabel-root': {
      color: theme.palette.text.primary,
      minWidth: 170,
      [theme.breakpoints.down('xs')]: {
        width: '100%'
      },
      [theme.breakpoints.up('sm')]: {
        margin: 0,
        paddingRight: theme.spacing(2)
      }
    },
    '& .MuiFormControl-root': {
      [theme.breakpoints.down('xs')]: {
        width: '100%'
      }
    }
  },
  SubmitRow: {
    padding: theme.spacing(4, 0),
    textAlign: 'center'
  },
  AdditionalInfoSubmit: {
    color: theme.palette.common.white,
    background: theme.palette.primary.light,
    border: 'none',
    padding: theme.spacing(1, 6),
    '&:disabled': {
      pointerEvents: 'none',
      opacity: 0.7
    },
    '&:hover, &:focus': {
      opacity: 0.7
    }
  }
}))
